import { defineMessages } from "react-intl";

const messages = defineMessages({
    startEdit: {
        id: "task.embed.startEdit",
    },
    stopEdit: {
        id: "task.embed.stopEdit",
    },
    loading: {
        id: "general.loading",
    },
    youtubeVideo: {
      id: "subscore.youtubeVideo",
    },
    scores: {
      id: "subscore.scores",
    },
    scoresSync: {
      id: "subscore.scoresSync",
    },
    opacity: {
        id: "subscore.opacity",
    },
    followNotes: {
        id: "subscore.followNotes"
    }
});

export default messages;
